<template>
  <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M15.792 31.584C7.07481 31.584 0 24.5092 0 15.792C0 7.07481 7.07481 0 15.792 0C24.5092 0 31.584 7.07481 31.584 15.792C31.584 24.5092 24.5092 31.584 15.792 31.584ZM6.73792 14.2549L14.1707 21.6877L24.5934 11.265L22.7405 9.41203L14.1917 17.9608L8.59084 12.3809L6.73792 14.2549Z" fill="#B5D23E"/>
  </svg>
</template>